<template>
  <div>
    <topup-progress />
    <topup-stage1 v-if="isStageActive(1)" />
    <topup-stage2 v-if="isStageActive(2)" />
    <topup-stage3 v-if="isStageActive(3)" />
  </div>
</template>

<script>
import TopupStage1 from '../components/Topup/Stage1'
import TopupStage2 from '../components/Topup/Stage2'
import TopupStage3 from '../components/Topup/Stage3'
import TopupProgress from '../components/Topup/Progress'
import { mapState } from 'vuex'
import TopupView from '../../common/mixins/views/TopupView.mixin'

export default {
  name: 'TopupView',
  mixins: [TopupView],
  components: {
    TopupStage3,
    TopupStage2,
    TopupStage1,
    TopupProgress
  },
  computed: {
    ...mapState({
      stage: state => state.topup.stage
    })
  },
  methods: {
    isStageActive (stage) {
      return this.stage === stage
    }
  }
}
</script>
